$(function() {
      $('.js-slide-spray').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        arrows: false,
        dots: false,
        variableWidth: true,
        centerMode: false,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        swipeToSlide: true
      });
      $('.js-slide-powder').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        arrows: false,
        dots: false,
        variableWidth: true,
        centerMode: false,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        swipeToSlide: true
      });
    });

window.addEventListener("scroll", function () {
  const header = document.querySelector(".header-wrapper");

  if (!header) return;

  if (window.scrollY > 50) {
    header.classList.add("is-scrolled");
  } else {
    header.classList.remove("is-scrolled");
  }
});


// 購入はこちらボタン　フッターが近づいたらフェードアウト
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".fixed-purchase-btn-wrapper");
  const footer = document.querySelector(".footer");

  if (!btn || !footer) return;

  function adjustButton() {
    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // フッターが近づいたらフェードアウト
    if (footerRect.top < windowHeight - 100) {
      btn.classList.add("is-hide");
    } else {
      btn.classList.remove("is-hide");
    }
  }

  window.addEventListener("scroll", adjustButton);
  window.addEventListener("resize", adjustButton);

  adjustButton();
});

// ドロワーメニューのアンカーリンククリック時にメニューを閉じる
document.addEventListener('click', function (e) {
  const link = e.target.closest('header-drawer a[href]');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href) return;

  const url = new URL(href, window.location.href);
  const isSamePageAnchor =
    url.hash &&
    url.pathname === window.location.pathname;

  const headerDrawer = link.closest('header-drawer');
  if (!headerDrawer) return;

  const rootDetails = headerDrawer.querySelector('#Details-menu-drawer-container');
  const rootSummary = rootDetails ? rootDetails.querySelector('summary') : null;

  const closeDrawer = () => {
    if (!rootDetails) return;

    // まずDawn本来の開閉経路で閉じる
    if (rootDetails.hasAttribute('open') && rootSummary) {
      rootSummary.click();
    }

    // 念のため強制的にも閉じる
    setTimeout(() => {
      rootDetails.removeAttribute('open');
      rootDetails.classList.remove('menu-opening');

      headerDrawer.querySelectorAll('details[open]').forEach((detail) => {
        detail.removeAttribute('open');
        detail.classList.remove('menu-opening');
      });

      if (rootSummary) {
        rootSummary.setAttribute('aria-expanded', 'false');
      }

      document.documentElement.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet'
      );
      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet'
      );
    }, 30);
  };

  // TOPにいる状態で #product を押した時
  if (isSamePageAnchor) {
    e.preventDefault();

    const target = document.querySelector(url.hash);

    closeDrawer();

    if (!target) return;

    setTimeout(() => {
      const header = document.querySelector('.section-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const targetY =
        target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }, 250);

    return;
  }

  // 別ページ遷移は閉じるだけ
  closeDrawer();
});